
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Custom hook to fetch nursing homes related to the current one (in the same county)
 * @param currentNhSlug The slug of the current nursing home to exclude from results
 * @param countySlug The county slug to filter by
 * @param limit Maximum number of related nursing homes to return
 */
export function useRelatedNursingHomes(
  currentNhSlug: string,
  countySlug: string,
  limit: number = 3
) {
  return useQuery({
    queryKey: ["related-nursing-homes", countySlug, currentNhSlug],
    queryFn: async () => {
      try {
        // Fetch nursing homes in the same county, excluding the current one
        const { data, error } = await supabase
          .from("nursing_homes")
          .select("*")
          .eq("county_slug", countySlug)
          .neq("nh_slug", currentNhSlug)
          .order("center_name")
          .limit(limit);

        if (error) {
          console.error("Error fetching related nursing homes:", error);
          throw new Error("Failed to fetch related nursing homes");
        }

        return data || [];
      } catch (err) {
        console.error("Error in query function:", err);
        throw err;
      }
    },
    enabled: !!countySlug && !!currentNhSlug,
  });
}
